import { Phone } from "lucide-react";
import { Reveal } from "@/lib/motion";
import { SITE } from "@/lib/site";
import { Link } from "react-router-dom";

export default function FinalCTA({ heading = "Ready for a more comfortable home?", text }) {
  return (
    <section className="dark-glow relative overflow-hidden" data-testid="final-cta">
      <div className="mx-auto max-w-7xl px-5 py-20 md:py-28">
        <Reveal className="max-w-3xl">
          <span className="font-display text-xs font-bold uppercase tracking-[0.25em] text-brand-cyan">
            Airconditioning Victoria
          </span>
          <h2 className="mt-4 font-display text-3xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-4xl lg:text-5xl">
            {heading}
          </h2>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-[#B9D3E5] md:text-lg">
            {text ||
              "Talk to Airconditioning Victoria about the right heating and cooling solution for your property."}
          </p>
          <div className="mt-9 flex flex-wrap items-center gap-4">
            <Link
              data-testid="final-cta-quote-btn"
              to="/contact"
              className="inline-flex items-center justify-center gap-2 rounded-[10px] bg-gradient-brand px-7 py-3.5 font-display text-sm font-bold tracking-wide text-white shadow-[0_10px_30px_rgba(24,185,207,0.35)] transition-[transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:shadow-[0_16px_40px_rgba(24,185,207,0.5)]"
            >
              Get a Free Quote
            </Link>
            <a
              data-testid="final-cta-phone-btn"
              href={SITE.phoneHref}
              className="inline-flex items-center justify-center gap-2 rounded-[10px] border border-white/25 px-7 py-3.5 font-display text-sm font-bold tracking-wide text-white transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-white/10"
            >
              <Phone className="h-4 w-4 text-brand-cyan" /> Call {SITE.phone}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
